// Load Atlassian Connect's `all.js` script.
window.Querier = require('querier');
(function(){
  const params = Querier.get();
  if (params.xdm_e) {
    const scriptUrl = params.xdm_e + (params.cp || '') + '/atlassian-connect/all.js';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptUrl;
    document.querySelector('body').appendChild(script);
  }
})();



// WEBPACK FOOTER //
// ./app/javascript/common/jira-ops-frame-loader.js